import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import ToothGraphic2 from '@/assets/images/Tooth-graphic-2.svg'
import {
  getAllInOneCeramicBrand,
  getEnamelLayerAdvice,
} from '@/utils/matisseV2/allInOne'

const SkinEnamelPDF = ({ recipe }) => {
  const brand = getAllInOneCeramicBrand(recipe)
  const enamelValue = (region: 'cervical' | 'middle' | 'incisal') =>
    getEnamelLayerAdvice(recipe, region) || '-'

  return (
    <Paper
      id="download-page-0"
      elevation={0}
      sx={{
        backgroundColor: '#FFF',
        px: 5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
      }}
    >
      <Grid container sx={{ height: '100%' }}>
        {/* Left Side */}
        <Grid item xs={4} sx={{ backgroundColor: 'white' }}>
          <Box
            component="img"
            src={ToothGraphic2}
            alt="Toothimage"
            sx={{ width: '233px', height: '330px' }}
          />
        </Grid>

        {/* Right Side */}
        <Grid
          item
          xs={8}
          container
          direction="column"
          sx={{ backgroundColor: '#f8f9fa', flexGrow: 1 }}
        >
          {/* Skin Enamel */}
          <Box display="flex" alignItems="center" m={2}>
            <Typography
              variant="h5"
              component="div"
              sx={{ marginRight: 2, color: 'black' }}
            >
              Skin Enamel:
            </Typography>
            {brand && (
              <Box
                sx={{
                  backgroundColor: '#F44336',
                  borderRadius: '16px',
                  padding: '8px',
                  color: 'black',
                  marginLeft: 1,
                }}
              >
                {brand}
              </Box>
            )}
          </Box>

          {/* Table Section */}
          <Box sx={{ px: 5, flexGrow: 1 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ fontWeight: 'bold', color: 'black' }}
                  ></TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: 'bold', color: 'black' }}
                  >
                    Cervical
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: 'bold', color: 'black' }}
                  >
                    Middle
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: 'bold', color: 'black' }}
                  >
                    Incisal
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: 'black' }}>
                    Enamel
                  </TableCell>
                  <TableCell align="center" sx={{ color: 'black' }}>
                    {enamelValue('cervical')}
                  </TableCell>
                  <TableCell align="center" sx={{ color: 'black' }}>
                    {enamelValue('middle')}
                  </TableCell>
                  <TableCell align="center" sx={{ color: 'black' }}>
                    {enamelValue('incisal')}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Grid>
      </Grid>

      {/* Divider */}
      <Box
        component="hr"
        sx={{
          backgroundColor: 'black',
          opacity: 1,
          margin: 0,
          border: 0,
          height: '1px',
        }}
      />
    </Paper>
  )
}

export default SkinEnamelPDF
